/**
 * @typedef {(IDLE_BLACK | IDLE_WHITE)} TypeAnimation An animation.
 */

/**
 * The 'IDLE_BLACK' animation.
 * @type {'idle-black'}
 * @constant
 */
const IDLE_BLACK = 'idle-black';

/**
 * The 'IDLE_WHITE' animation.
 * @type {'idle-white'}
 * @constant
 */
const IDLE_WHITE = 'idle-white';

export {

    IDLE_BLACK,
    IDLE_WHITE
};
